import Moment from 'moment-timezone'
import React, { Component } from 'react'

import { AgGridReact } from 'ag-grid-react';

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

import ValueFormatter from '../components/value-formatter'

function CustomPinnedRowRenderer () {}

CustomPinnedRowRenderer.prototype.init = function(params) {
    this.eGui = document.createElement('div')
    this.eGui.style = params.style
    this.eGui.innerHTML = params.value
}

CustomPinnedRowRenderer.prototype.getGui = function() {
    return this.eGui
}

function createTotalPinnedData(gridApi) {

  var result = {
    transaction_date :null,    
    notes:"TOTALS",
    amount_out : 0,
  }
  
  gridApi.forEachNode(row => {
    result.amount_out += row.data.amount_out ? parseFloat(row.data.amount_out) : 0
  })

  result.amount_out = result.amount_out.toFixed(2)

  return [result]
}

const numberSort = (num1,num2) => {
  return num1 - num2
}

class BankAccountGrid extends Component {

  onGridReady = params => {
    params.api.setGridOption('pinnedBottomRowData', createTotalPinnedData(params.api))
  }
   
  dateCellClass = date => {

    if (Moment(date).year() !== this.props.year)
    {
      return "wrongYear"
    }
  }

  render() {

    return (
      <div className="ag-theme-alpine" style={ {width: '100%'} }>
        <AgGridReact
          rowHeight={44}
          onGridReady={this.onGridReady}
          rowData={this.props.dividends}
          onRowDoubleClicked={item => this.props.actionClickHandler("view",item.data)}
          domLayout='autoHeight'
          columnDefs={[
            {
              field: "transaction_date",
              headerName: "Date",
              menuTabs : [],
              valueFormatter : item => ValueFormatter.formatDate(item.value),
              cellClass : item => this.dateCellClass(item.value),
              sortable: true,
              filter: 'agDateColumnFilter',
              filterParams : {
                filterOptions : ['inRange','equals','empty'],
                suppressAndOrCondition : true,
                inRangeInclusive : true,
                comparator : function (filter, value) {
                  let filterMoment = Moment(filter)
                  let valueMoment = Moment(value).tz('Europe/London')
        
                  if (valueMoment.isSame(filterMoment,'day')) return 0
                  if (valueMoment.isBefore(filterMoment,'day')) return -1
                  if (valueMoment.isAfter(filterMoment,'day')) return 1
                },
              },
              width : 150,
            },
            {
              field: "name",
              headerName: "Name",
              cellClass : 'textGridCell',
              menuTabs : [],
              sortable: false,
              comparator: numberSort,
              filter: false,
              width : 300,
            },
            {
              field: "notes",
              headerName: "Notes",
              cellClass : 'textGridCell',
              menuTabs : [],
              sortable: false,
              comparator: numberSort,
              filter: false,
              width : 300,
            },
            {
              field: "amount_out",
              headerName: "Amount",
              headerClass : "rightAlignHeader",
              cellClass : 'numberGridCell',
              menuTabs : [],
              sortable: false,
              valueFormatter : item => ValueFormatter.formatMoneyOrNull(item.value),
              filter: true,
              width : 120,
            },
          ]}
          components = {{
            customPinnedRowRenderer: CustomPinnedRowRenderer,
          }}
          >
        </AgGridReact>
      </div>
    )
  }
}

export default (BankAccountGrid)
